import apiClient from "./client";

export const getAdminCareerJobs = async () => {
  const response = await apiClient.get("/careers/admin/jobs");
  return response.data;
};

export const createAdminCareerJob = async (payload) => {
  const response = await apiClient.post("/careers/admin/jobs", payload);
  return response.data;
};

export const updateAdminCareerJob = async ({ id, payload }) => {
  const response = await apiClient.put(`/careers/admin/jobs/${id}`, payload);
  return response.data;
};

export const deleteAdminCareerJob = async ({ id }) => {
  await apiClient.delete(`/careers/admin/jobs/${id}`);
};

export const getAdminCareerApplications = async ({ status, jobId } = {}) => {
  const params = {};
  if (status) params.status = status;
  if (jobId) params.jobId = jobId;
  const response = await apiClient.get("/careers/admin/applications", { params });
  return response.data;
};

export const updateAdminCareerApplicationStatus = async ({ id, status }) => {
  const response = await apiClient.put(`/careers/admin/applications/${id}/status`, { status });
  return response.data;
};

export const deleteAdminCareerApplication = async ({ id }) => {
  await apiClient.delete(`/careers/admin/applications/${id}`);
};
